import { Link } from "react-router-dom";

const BULLET = /^\s*([-*•]|\d+[.)])\s+/;

const links = (t, k) =>
  t.split(/(\[[^\]]+\]\(\/[^)\s]*\))/g).map((p, i) => {
    const m = p.match(/^\[([^\]]+)\]\((\/[^)\s]*)\)$/);
    return m ? <Link key={`${k}-${i}`} to={m[2]} className="text-[#8C6D62] underline underline-offset-2">{m[1]}</Link> : p;
  });

const inline = (t) =>
  t.split(/(\*\*[^*]+\*\*)/g).map((p, i) => (p.startsWith("**") && p.endsWith("**") ? <strong key={i} className="font-semibold">{links(p.slice(2, -2), i)}</strong> : links(p, i)));

export const RichText = ({ text }) => (
  <div className="space-y-2.5 leading-relaxed">
    {text.split(/\n{2,}/).map((block, i) => {
      const lines = block.split("\n").filter((l) => l.trim());
      if (lines.length && lines.every((l) => BULLET.test(l)))
        return <ul key={i} className="list-disc pl-5 space-y-1">{lines.map((l, j) => <li key={j}>{inline(l.replace(BULLET, ""))}</li>)}</ul>;
      return (
        <p key={i}>
          {lines.map((l, j) => (
            <span key={j}>{inline(l.replace(/^#+\s*/, "").replace(BULLET, "• "))}{j < lines.length - 1 && <br />}</span>
          ))}
        </p>
      );
    })}
  </div>
);
